import { getTestId } from '@airtel/air-design-system';
export var defaultProps = Object.assign({
  setCheckedBoxState: true,
  isValid: true,
  checkboxData: {
    label: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor cutres',
    actionCta: 'terms and conditions'
  },
  onActionCtaPressMetaData: {
    id: 'actioncta'
  },
  buttonData: {
    onLeftCtaPress: {
      id: 'left cta press'
    },
    leftCta: {
      title: 'BUTTON',
      buttonType: 'primary',
      size: 'lg'
    }
  }
}, getTestId('AnchoredActionWidgetContainer'));